import * as types from './project-task.types';
import * as constants from './project-task.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeProjectTask = generateStoreResourceAction<types.IProjectTask>(constants.STORE_PROJECT_TASK);
export const clearProjectTask = generateClearResourceAction(constants.CLEAR_PROJECT_TASK);
